import React from 'react';
import FooterSocialIcons from './FooterSocialIcons';
import { ArrowRightIcon } from './Icons';

import '../js/cookie.js';
import '../css/cookie.css';

const footerH5 = {
  fontWeight: "700",
  color: "#2b185a",
}

const footerCAll = {
  fontSize: "14px",
  lineHeight: "10px",
  color: "#707070",
  marginTop: "15px"
}

const footerContact = {
  color: "#2b185a",
  fontWeight: "600",
  textDecoration: "none"
}

// One set of footer links: columns on desktop, collapsible accordion on mobile (see .footer-group in App.css).
const footerGroups = [
  {
    id: 'company', title: 'Company', colClass: 'col-md-1 wrapper-col-2', links: [
      { href: '/about-us', label: 'About us' },
      { href: '/contact-us', label: 'Contact us' },
      { href: 'https://www.ttkservices.com/career/career.php', label: 'Careers', external: true },
      { href: '/press-and-media', label: 'Press' },
      { href: 'https://www.getfriday.com/blog/', label: 'Blog', external: true },
    ]
  },
  {
    id: 'getfriday', title: 'GetFriday', colClass: 'col-md-2 wrapper-col-3', links: [
      { href: '/why-getfriday', label: 'Why GetFriday' },
      { href: '/how-we-work', label: 'How it works' },
      { href: '/faqs', label: "FAQ's" },
      { href: '/sitemap', label: 'SiteMap' },
      { href: '/4-hour-workweek-ymii', label: '4-Hour Workweek' },
    ]
  },
  {
    id: 'services', title: 'Services', colClass: 'col-md-2 wrapper-col-4', links: [
      { href: '/personal/virtual-personal-assistant', label: 'Personal VA' },
      { href: '/business/services', label: 'Business Support' },
      { href: '/business/bookkeeping-service', label: 'BookKeeping' },
      { href: '/business/website-services', label: 'Website Development' },
      { href: '/business/digital-marketing', label: 'Digital Marketing' },
    ]
  },
  {
    id: 'legal', title: 'Legal', colClass: 'col-md-2 wrapper-col-5', links: [
      { href: '/privacy-policy', label: 'Privacy Policy' },
      { href: '/terms-and-conditions', label: 'Terms & Conditions' },
      { href: '/refund-policy', label: 'Refund Policy' },
      { href: '/disclaimer', label: 'Disclaimer' },
      { href: '/copyright', label: 'Copyright' },
    ]
  },
];

const FooterGroup = ({ group }) => (
  <div className={`${group.colClass} footer-group accordion-item`}>
    <h6 className="accordion-header footer-heading mt-2" id={`footer-heading-${group.id}`}>
      <button className="accordion-button collapsed footer-topic" type="button" data-bs-toggle="collapse" data-bs-target={`#footer-links-${group.id}`} aria-expanded="false" aria-controls={`footer-links-${group.id}`}>{group.title}</button>
    </h6>
    <div id={`footer-links-${group.id}`} className="accordion-collapse collapse" aria-labelledby={`footer-heading-${group.id}`}>
      <ul className="footer-list-ul pt-2">
        {group.links.map(link => (
          <li className="footer-list pb-2" key={link.href}>
            {link.external
              ? <a href={link.href} target="_blank" rel="noopener noreferrer" className="footer-list-link">{link.label}</a>
              : <a href={link.href} className="footer-list-link">{link.label}</a>}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

const Footer = () => {
  return (
    <>
      <footer className="worldwide pb-3 pt-5">
        <div className="container-fluid ps-3 pe-3 ps-md-5 pe-md-5">
          <div className="secoundry-footer">
            <div className="row">
              <div className="col-md-9 col-12">
                <h4 style={footerH5}>Feel free to call us. We are available 24/7 for your support.</h4>
                <p style={footerCAll} className="mb-2">CALL US AT</p>
                <p style={footerContact}>UK:
                  <a style={footerContact} href="tel:+44-800-102-6200"> +44-800-102-6200 </a>/ US: <a href="tel:+1-877-879-4339" style={footerContact}>+1-877-879-4339 </a>/ AUS: <a href="tel:+61-871-401-005" style={footerContact}>+61-871-401-005 </a>
                </p>
              </div>
              <div className="col-md-3 col-12 text-end">
                <a className="nav-link btn header-menu-btn gf-btn me-3 mt-3" href="/contact-us">
                  <span className="d-flex align-content-center justify-content-center pt-1 pb-1">Get in touch <ArrowRightIcon className="ms-1" /></span>
                </a>
              </div>
              <div className="col-md-12">
                <hr></hr>
              </div>
            </div>
          </div>
          <div className="primary-footer">
            <div className="row justify-content-around accordion accordion-flush">
              <div className="col-md-3 wrapper-col-1">
                <img alt="GetFriday" className="img-fluid mb-3" src="/assets/images/GF-logo.svg" style={{ width: "150px" }} />
                <p className="footer-text" style={{ textAlign: "justify" }}>GetFriday, the World's leading Virtual Assistant services since 2005. We help busy individuals, Startups &amp; Small businesses, handle their personal and business needs better.</p>
              </div>

              {footerGroups.map(group => <FooterGroup group={group} key={group.id} />)}

              <div className="col-md-2 wrapper-col-6 footer-social-col">
                <h6 className="footer-heading pb-1 mt-2 hide-in-mobile">Social Links</h6>
                <FooterSocialIcons />
                <img loading="lazy" decoding="async" src="/assets/images/Thumb_mark.jpg" height="70px" alt="BSI ISO/IEC 27001 Information Security Management certified"></img>
              </div>
              <div className="col-md-12 footer-copyright-col">
                <p className="pt-4 text-center copyrights footer-text"> © {new Date().getFullYear()} Copyright, All Rights Reserved, Made by GetFriday</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer